import type { Entry, EntrySkeletonType, UnresolvedLink } from 'contentful';

/**
 * A fieldless payload would throw and fail the whole SSR shell, so it degrades instead.
 * `NoInfer` pins `TFields` to the nested `fields` slot so Entry-native props still typecheck.
 */
export function getEntryNativeFields<TFields extends object>(props: { fields: TFields } | NoInfer<TFields>): TFields {
  return 'fields' in props ? props.fields : props;
}

export const isResolvedEntry = <ResolvedEntry extends Entry<EntrySkeletonType, 'WITHOUT_UNRESOLVABLE_LINKS'>>(
  item: ResolvedEntry | UnresolvedLink<'Entry'> | undefined,
): item is ResolvedEntry => item != null && 'fields' in item;
